import { type AppDispatch, type RootState } from '../../../../../store'
import _ from 'lodash'
import { addOffer } from '../../../addOffer'
type AddOfferIndividualOfferDetailsData = Record<string, any>
export const addOfferCompanySaleOfferDetails = (unitID: string | undefined, objectID: string | undefined) => (data: AddOfferIndividualOfferDetailsData) => async (dispatch: AppDispatch, getState: () => RootState) => {
    const savedData = _.cloneDeep(getState().modal.scannedData.formData)
    const offerData = {
        ...data,
        ...savedData,
        Type: {
            ...data?.Type,
            ...savedData?.Type
        }
    }
    return await dispatch(addOffer(offerData, 'sale-commercial', Number(unitID), objectID !== '-' ? Number(objectID) : undefined))
}
